import { TDateRangeField } from 'src/components/Lead/Filters/components/types';


export const TICKET_DATE_RANGE_FIELDS: TDateRangeField[] = ['createdAt'];

export const DATE_RANGE_FIELDS: TDateRangeField[] = [
    'createdAt',
    'closureDate',
    'currentTask',
    'appointmentDate',
    'visitDate',
    'lastTask',
    'firstTask',
    'firstContact',
    'assignedDate',
    'creditBureau.scoreDate',
    'vehicleDeliveryDate',
];
